export default "__VITE_ASSET__uLq$AFOG__"